import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=517f56bd&scoped=true"
import script from "./noticelist.vue?vue&type=script&lang=js"
export * from "./noticelist.vue?vue&type=script&lang=js"
import style0 from "./noticelist.vue?vue&type=style&index=0&id=517f56bd&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517f56bd",
  null
  
)

export default component.exports